import React, { Component } from 'react';
import AddSubCategoryForm from '../../../components/SiteAdmin/AddSubCategoryForm/AddSubCategoryForm';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import getSubCategory from './getSubCategory.graphql';

function parseInclusions(raw) {
    if (!raw) return [''];
    try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) && parsed.length ? parsed : [''];
    } catch (e) {
        return [''];
    }
}
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Loader from '../../../components/Common/Loader/Loader';
import getActiveCategories from '../addSubCategory/getActiveCategories.graphql';
import s from './EditSubCategory.css';

export class EditSubCategory extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired
    }
    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { data: { loading, getSubCategory }, data, id } = this.props;
        const { categories } = this.props;

        let initialValues = {};

        if (!loading && getSubCategory.status === 200 && getSubCategory.result) {
            initialValues = {
                id: getSubCategory.result.id,
                name: getSubCategory.result.name,
                description: getSubCategory.result.description,
                // Stored as a JSON array; redux-form's FieldArray wants a real
                // array. A malformed or empty value yields one blank row so the
                // form still has something to type into.
                inclusions: parseInclusions(getSubCategory.result.inclusions),
                // Tanpa baris ini nilainya tidak pernah sampai ke form, dan
                // submit mengirim null — menyimpan subkategori apa pun akan
                // MENGHAPUS "Typical arrival" yang sudah diisi.
                typicalArrival: getSubCategory.result.typicalArrival,
                image: getSubCategory.result.image,
                categoryId: getSubCategory.result.categoryId,
                status: getSubCategory.result.status
            }
        }
        return (
            <Loader type={"page"} show={loading}>
                <div className={s.root}>
                    <div className={s.container}>
                        <div className={s.paddingRoutesSection}>
                            {!loading && <AddSubCategoryForm initialValues={initialValues} categories={categories} />}
                        </div>
                    </div>
                </div>
            </Loader>
        )
    }
}

export default compose(withStyles(s),
    graphql(getSubCategory, {
        options: (props) => ({
            variables: {
                id: props.id
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }),
    graphql(getActiveCategories, {
        name: 'categories',
        options: {
            ssr: true,
            fetchPolicy: 'network-only'
        }
    }))(EditSubCategory)
